enum BreakpointTypeEnum {
  Screen = 'Screen', // Represents the screen size breakpoint, ignoring the zoom
  Viewport = 'Viewport', // Represents the viewport/displayed size breakpoint, including the zoom
}

export default BreakpointTypeEnum;
